import React from "react";
import "@layouts/index.scss";
import {Layout} from 'antd';
import LeftMenu from "@components/LeftMenu";
import MenuMobile from "@components/MenuMobile";

const {Content, Header, Sider} = Layout;

const SubLayout = ({children}) => {
  return (
    <React.Fragment>
      <Layout className="layout-wrapper">
        <Sider className="slider-left" width={280}><LeftMenu/></Sider>
        <Content>
          <Header className="header-mobile"><MenuMobile/></Header>
          <Layout>
            <Content className="content-menu-wrapper">
              {children}
            </Content>
          </Layout>
        </Content>
      </Layout>
    </React.Fragment>
  );
};

export default SubLayout;
